import { Box, CircularProgress } from "@mui/material";
import type { JSX, ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "./AuthProvider.js";

/**
 * The onboarding wall's guard (spec E §10.2) — the mirror of `RequireAuth`.
 *
 * A FULL reseller arriving at /onboarding is sent to the portal: they have
 * finished the process this page exists for, and a form asking them to sign
 * documents again would read as a bug. Nobody at all goes to /login, which
 * will bring an applicant straight back here after gate 3b.
 *
 * Like `RequireAuth`, this decides what to RENDER. The BFF's
 * `requireApplicant` is what decides what the wall may read.
 */
export function RequireApplicant({ children }: { children: ReactNode }): JSX.Element {
  const { user, applicant, status } = useAuth();

  if (status === "loading") {
    return (
      <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", bgcolor: "background.default" }}>
        <CircularProgress size={28} sx={{ color: "accent.500" }} aria-label="Loading" />
      </Box>
    );
  }

  if (user) return <Navigate to="/" replace />;
  if (!applicant) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
